import React from 'react';
import PropTypes from 'prop-types';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import AgencyWithdrawView from 'features/Agency/components/AgencyWithdrawView';

AgencyWithdrawScreen.propTypes = {};

function AgencyWithdrawScreen(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid p-0">
        <AgencyWithdrawView />
      </div>
    </KT01BaseLayout>
  );
}

export default AgencyWithdrawScreen;
